export const userRoles = [
  { id: 'SUAD', name: 'Admin' },
  { id: 'USR', name: 'User' },
];
